import { Injectable, Inject } from '@angular/core';
import { HttpModule, Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { APP_CONFIG, IAppConfig } from './../app.config';
import 'rxjs/add/observable/throw';

@Injectable()

export class FlexQuestionsService {

  private _token: string = localStorage.getItem('token');
  constructor(
    private http: Http,
    @Inject(APP_CONFIG) private config: IAppConfig
  ) { }


  getQuestionsData$(): Observable<any> {
    const headers = new Headers({ 'Authorization': this._token });
    const options = new RequestOptions({ headers: headers });
    const partnerurl=window.location.hostname.split('.').shift();

    return this.http.get(this.config.apiEndpoint + 'flexQuestionStore/' + partnerurl, options).map((res => res.json()))
    .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  patchQuestionsData$(segment:any): Observable<any> {
    let token = this._token;
    const headers = new Headers({ 'Content-Type': 'application/json','Authorization': token});
    const partnerurl=window.location.hostname.split('.').shift();

    return this.http.patch(this.config.apiEndpoint + 'flexQuestionStore/'+partnerurl , segment, {
        headers: headers
      })
      .catch(this.handleErrorObservable);
  }

  submitApplication(obj:any): Observable<any> {
    let token = this._token;
    const headers = new Headers({ 'Content-Type': 'application/json','Authorization': token});
    const partnerurl=window.location.hostname.split('.').shift();

    return this.http.post(this.config.apiEndpoint + 'flexQuestionStore/'+partnerurl+'/Submit' , !!obj?obj:{}, {
        headers: headers
      })
      .catch(this.handleErrorObservable);
  }

  getFinalSummary(): Promise<any> {
    let token = this._token;
    const headers = new Headers({ 'Content-Type': 'application/json','Authorization': token});
    const options = new RequestOptions({ headers: headers });
    const partnerurl=window.location.hostname.split('.').shift();

    // I hate that you have to constantly maintain subscription pointers in client code when
    // most of my calls are one request, one response.
    return new Promise((resolve,reject)=>{
      var sub=this.http.get(this.config.apiEndpoint + 'finalSummary/'+partnerurl,options).map((res => res.json()))
        .catch((error: any) => {
          let val:any;
          try {
            val=error.json();
          } catch(err) {
            val='Server error';
          }
          return Observable.throw(val);
        }).subscribe(
          (success)=>{
            sub.unsubscribe();
            resolve(success);
          },
          (err)=>{
            sub.unsubscribe();
            reject(err);
          }
        );
    });
  }

  getCompletionStatus(): Promise<any> {
    let token = this._token;
    const headers = new Headers({ 'Content-Type': 'application/json','Authorization': token});
    const options = new RequestOptions({ headers: headers });
    const partnerurl=window.location.hostname.split('.').shift();

    // I hate that you have to constantly maintain subscription pointers in client code when
    // most of my calls are one request, one response.
    return new Promise((resolve,reject)=>{
      var sub=this.http.get(this.config.apiEndpoint + 'completionStatus/'+partnerurl,options).map((res => res.json()))
        .catch((error: any) => {
          let val:any;
          try {
            val=error.json();
          } catch(err) {
            val='Server error';
          }
          return Observable.throw(val);
        }).subscribe(
          (success)=>{
            sub.unsubscribe();
            resolve(success);
          },
          (err)=>{
            sub.unsubscribe();
            reject(err);
          }
        );
    });
  }

  private handleErrorObservable (error: Response | any) {
    /*if(!error.json().error){
      alert('Please check your internet connection');
    }*/
    return Observable.throw( error.json().error || 'Server Error' );
  }

}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/_services/flex-questions.service.ts